export enum BrowserStorageType {
  temporary,
  permanent,
}
